import {
    WapiService,
} from 'wanderu-service-wapi';
import { extractTemplate } from 'wanderu-utils';

let prevLocale;
let prevPolicy;
let fetchPromise;

async function _fetchData(locale, policy) {
    const updatedLocale = prevLocale && prevLocale !== locale;
    const updatedPolicy = prevPolicy && prevPolicy !== policy;
    if (updatedLocale || updatedPolicy) {
        fetchPromise = undefined;
    }

    prevLocale = locale;
    prevPolicy = policy;

    let pageType = policy;
    if (policy === 'terms-and-conditions') {
        pageType = 'terms_conditions';
    }

    if (!fetchPromise) {
        fetchPromise = WapiService.getTranslations({
            locale,
            pageType: pageType.replace(/-/g, '_'),
        });
    }

    return fetchPromise;
}

async function getTranslations(locale, policy) {
    const response = await _fetchData(locale, policy);
    return response.result.content;
}

async function getContent({ locale, policy }) {
    const response = await _fetchData(locale, policy);
    return extractTemplate(response.result.content);
}

export {
    getContent,
    getTranslations,
};
